import { apiManager } from './apiManager';

export const ourWorkApi = {
  getOurWork: async () => await apiManager.get('/dashboard/century/services/our-works'),
};
